import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IManagableObject } from "../../../IManagableObject";
import { UserViewModel } from "../../../../../services/users.service";
import { NameAndListFilterModel } from "../../../../shared/pipes/FilterByNameAndList.pipe";
import { CompanyModel } from 'app/services/companies.service';

export interface IOwnableEntity extends IManagableObject {
  Id: number;
  Name: string;
  IsChecked: boolean;
  //OwnerName: string;
  OwnerId: number;
}


@Component({
    selector: 'app-entities-list',
    templateUrl: './entities-list.component.html',
    styleUrls: ['./entities-list.component.css'],
    standalone: false
})
export class EntitiesListComponent implements OnInit {
  public term = new NameAndListFilterModel();
  public selectObjectsCount: number = 0;
  public hideDublicate = false;

  @Input('company')
  public currentCompany: CompanyModel;

  @Input('companies')
  private companies: CompanyModel[] = [];

  @Input('entities')
  public objects: IOwnableEntity[] = [];

  @Input('filterentities')
  public filterobjects: IOwnableEntity[] = [];

  @Input('deletedOnly')
  public deletedOnly: boolean = false;

  @Input()
  public IsCopyControl: boolean = false;

  @Output()
  public onDeleteClicked: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();

  constructor() {
  }

  ngOnInit() {
  }

  public onTermChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.term.term = input.value;
  }


  public onToggleAll(value: boolean) {
    this.objects.forEach((command) => {
      command.IsChecked = value;
    });
  }

  public GetCompanyName(id: number): string {
    return this.companies.find(x => x.Id == id)?.Name ?? "";
  }

  public GetObjects() {
    return this.deletedOnly ? this.objects.filter(x => x.OwnerId != this.currentCompany.Id) : this.objects;
  }

  public onToggle(val: any) {
    this.selectObjectsCount = this.objects.filter(c => c.IsChecked).length;
  }

  public switchDublicateHiding() {
    this.hideDublicate = !this.hideDublicate;
    this.term.excludelist = this.hideDublicate ? this.filterobjects : [];
  }

  deleteEntity(Id: number) {
    this.onDeleteClicked.emit([Id]);
  }
  public showCheckBox(object: IOwnableEntity) {
    if (this.deletedOnly) {
      if (object.OwnerId != this.currentCompany.Id) {
        return true;
      }
      else {
        return false;
      }
    } else {
      return true;
    }
  }
}
